import React, { useEffect, useState } from 'react';

function PlantStatus() {
  const [value, setValue] = useState(null);
  const [status, setStatus] = useState(null);

  useEffect(() => {
    let isMounted = true;
    const fetchStatus = async () => {
      try {
        const res = await fetch('/api/plant-status.php');
        const data = await res.json();
        if (isMounted) {
          const latestValue = parseFloat(data.value);
          setValue(!Number.isNaN(latestValue) ? latestValue : null);
          setStatus(typeof data.status === 'string' ? data.status : null);
        }
      } catch (err) {
        console.error(err);
      }
    };
    fetchStatus();
    const id = setInterval(fetchStatus, 60000);
    return () => {
      isMounted = false;
      clearInterval(id);
    };
  }, []);

  const running =
    status !== null ? status === 'Plant Running' : value !== null && value > 30;
  const statusText =
    status !== null ? status : running ? 'Plant Running' : 'Plant Stopped';

  return (
    <div
      className={`flex items-center px-3 py-1 rounded-full text-sm font-medium mr-4 ${
        running ? 'bg-green-600' : 'bg-red-600'
      }`}
    >
      <span className="relative flex h-3 w-3 mr-2">
        <span
          className={`animate-ping absolute inline-flex h-full w-full rounded-full opacity-75 ${
            running ? 'bg-green-400' : 'bg-red-400'
          }`}
        ></span>
        <span
          className={`relative inline-flex rounded-full h-3 w-3 ${
            running ? 'bg-green-500' : 'bg-red-500'
          }`}
        ></span>
      </span>
      {status === null && value === null ? '...' : statusText}
    </div>
  );
}

export default PlantStatus;

